import { t } from "@/i18n-js/instance";
import { Button } from "@circle-react-uikit/Button";
import { formId, i18nRoot } from "./constants";
import { downloadFile } from "./utils/downloadFile";

interface ModalFooterProps {
  downloadUrl?: string;
  isSubmitDisabled: boolean;
}

export const ModalFooter = ({
  isSubmitDisabled,
  downloadUrl,
}: ModalFooterProps) => (
  <div className="flex w-full justify-end gap-4">
    <Button
      type="button"
      variant="secondary"
      onClick={() => downloadFile(downloadUrl)}
    >
      {t(`${i18nRoot}.download_file`)}
    </Button>
    <Button
      type="submit"
      form={formId}
      variant="circle"
      disabled={isSubmitDisabled}
    >
      {t("save")}
    </Button>
  </div>
);
